import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import RefreshIcon from '@mui/icons-material/Refresh';

import { hasTrussDesignPermission } from '@paragon/login-tools';

import { useAppMonitor } from '../../../../monitor';
import { deleteAllSplices } from '../../../../store/actions/deletionActions';
import { startInsertSplice } from '../../../../store/actions/insertActions';
import { autoSplice } from '../../../../store/actions/paragonProcessActions';
import { getActiveComponentDesign } from '../../../../store/selectors/getActiveComponentDesignSelector';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { SceneMenuContent } from '../common/SceneMenuContent';
import { SceneMenuItem } from '../common/SceneMenuItem';

export function SplicesContainerMenu() {
  const dispatch = useAppDispatch();
  const monitor = useAppMonitor();

  const componentDesign = useAppSelector(getActiveComponentDesign);
  const isTrussDesigner = useAppSelector(hasTrussDesignPermission);

  if (componentDesign == null) return null;

  return (
    <SceneMenuContent>
      <SceneMenuItem
        text="Add Splice"
        icon={<AddIcon />}
        onClick={() => {
          dispatch(startInsertSplice());
        }}
      />

      <SceneMenuItem
        text="Delete All Splices"
        icon={<DeleteIcon />}
        onClick={() => {
          dispatch(deleteAllSplices());
        }}
      />

      {isTrussDesigner && (
        <SceneMenuItem
          text="Auto-Splice"
          icon={<RefreshIcon />}
          onClick={() => {
            dispatch(autoSplice(componentDesign));
            monitor.recordInteraction('Auto-Splice button clicked');
          }}
        />
      )}
    </SceneMenuContent>
  );
}
